<template>
<div>
<dl class="clearfix mt20">
  <dt><h6><i aria-hidden="true" :class="icon"></i>{{category}}</h6></dt>
  <dd></dd>
</dl>
<dl v-for="language in languages" class="clearfix" v-bind:key="language.id">
  <dt>{{language.name}}</dt>
  <dd>
    <b v-for="skillLevel in language.good"></b>
    <em v-for="max in language.max - language.good"></em>
  </dd>
</dl>
</div>
</template>

<script>
export default {
  name: 'skills',
  props: {
    category: String,
    languages: Array,
    icon: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Skills.vue